import { safeDefineElement } from '@/scripts/core/global'
import { DeferredMedia } from '@/scripts/theme/deferred-media'
import { DetailsDisclosure } from '@/scripts/theme/details-disclosure'
import { SliderComponent } from '@/scripts/theme/slider-component'
import { SlideshowComponent } from '@/scripts/theme/slideshow-component'
import { StickyHeader } from '@/scripts/theme/sticky-header'
import { UcoastVideo } from '@/scripts/core/ucoast-video'
import { ProductInfo } from '@/scripts/product/product-info'
import { ProductForm } from '@/scripts/product/product-form'
import { VariantSelects } from '@/scripts/theme/variant-selects'
import { VariantRadios } from '@/scripts/theme/variant-radios'
import { QuickAddCard } from '@/scripts/product/quick-add-card'
import {InteractiveRichText} from "@/scripts/theme/interactive-rich-text";
import {ShadowDomWrapper} from "@/scripts/theme/shadow-dom-wrapper";
import {KlaviyoForm} from "@/scripts/theme/klaviyo-form";
import {KlaviyoPopup} from "@/scripts/theme/klaviyo-popup";
import {KlaviyoOosPopup} from "@/scripts/theme/klaviyo-oos-popup";
import {KlaviyoOosForm} from "@/scripts/theme/klaviyo-oos-form";
import {BasicAccordion} from "@/scripts/theme/basic-accordion";
import {UcoastSelect} from "@/scripts/theme/ucoast-select";
import {RecipeCta} from "@/scripts/theme/recipe-cta";
import {ProductTooltip} from "@/scripts/theme/product-tooltip";
import {BasicTabs} from "@/scripts/theme/basic-tabs";
import {TaggedBlogSlider} from "@/scripts/theme/tagged-blog-slider";
import {GiftCardData} from "@/scripts/customer/gift-card-data";
import {PaginateButton} from "@/scripts/theme/pagination-button";
import {BundleCardPrice} from "@/scripts/product/bundle-card-price";
import {BundleQuickAdd} from "@/scripts/product/bundle-quick-add";
import {BundleComponent} from "@/scripts/bundle";
import {ArticleVideoModal} from "@/scripts/theme/article-video-modal";


safeDefineElement(DeferredMedia)
safeDefineElement(SliderComponent)
safeDefineElement(SlideshowComponent)
safeDefineElement(StickyHeader)
safeDefineElement(DetailsDisclosure)
safeDefineElement(UcoastVideo)
safeDefineElement(ProductInfo)
safeDefineElement(ProductForm)
safeDefineElement(VariantSelects)
safeDefineElement(VariantRadios)
safeDefineElement(QuickAddCard)
safeDefineElement(InteractiveRichText)
safeDefineElement(ShadowDomWrapper)
safeDefineElement(KlaviyoForm)
safeDefineElement(KlaviyoPopup)
safeDefineElement(KlaviyoOosPopup)
safeDefineElement(KlaviyoOosForm)
safeDefineElement(BasicAccordion)
safeDefineElement(BasicTabs)
safeDefineElement(UcoastSelect)
safeDefineElement(ProductTooltip)
safeDefineElement(RecipeCta)
safeDefineElement(TaggedBlogSlider)
safeDefineElement(GiftCardData)
safeDefineElement(PaginateButton)
safeDefineElement(BundleCardPrice)
safeDefineElement(BundleQuickAdd)
safeDefineElement(BundleComponent)
safeDefineElement(ArticleVideoModal)
